import React, { useRef, useEffect, useState } from "react";
import { Tooltip } from "@material-ui/core";
import { useLocation } from "react-router-dom";
import { DeviceUnknown, Bluetooth, Wifi } from "@material-ui/icons";
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import { useHistory } from "react-router-dom";
import MovimiI from "./mov.png"
import "./styles.css";

let test = [
  {
    posiciones: { puntoX: -1125, puntoY: -1170 },
    longitudes: { maxX: 22, maxY: 18.5 },
    valores: false,
    nombreArea: "Climatizado 01",
  },
  {
    posiciones: { puntoX: -1125, puntoY: -1550 },
    longitudes: { maxX: 22, maxY: 23 },
    valores: { temperature: 2.5 },
    nombreArea: "Climatizado 02",
  }
]


const ImageWithPoints = ({ imageUrl, data, dataGateways, dataArea }) => {

  const imageRef = useRef(null);
  const [imageWidth, setImageWidth] = useState(0);
  const [imageHeight, setImageHeight] = useState(0);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [title, setTitle] = useState("");
  const [blink, setBlink] = useState(false);
  const [logoColor, setLogoColor] = useState("black");
  const query = new URLSearchParams(useLocation().search);
  const organizacionn = query.get("organizacion");
  const localizacionn = query.get("localizacion");
  let history = useHistory();


  useEffect(() => {
    if (imageRef.current) {
      const image = new Image();
      image.src = imageUrl;
      image.onload = () => {
        setImageWidth(image.width);
        setImageHeight(image.height);
      };
    }
  }, [imageUrl]);

  useEffect(() => {
    const interval = setInterval(() => {
      const index = Math.floor(Math.random() * data.length);
      const { nombre } = data[index];
      setTitle(nombre);
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, [data]);

  useEffect(() => {
    const blinkInterval = setInterval(() => {
      setBlink((prevState) => !prevState);
    }, 1000);

    return () => {
      clearInterval(blinkInterval);
    };
  }, []);

  useEffect(() => {
    if (blink) {
      setLogoColor("black");
    } else {
      setLogoColor("white");
    }
  }, [blink]);



  const calculateScaledCoordinates = (posX, posY) => {
    const scaledX = ((posX + imageWidth) / imageWidth) * 100;
    const scaledY = ((posY + imageHeight) / imageHeight) * 100;
    return { x: scaledX, y: scaledY };
  };

  const getDeviceIcon = (catalogo) => {
    switch (catalogo) {
      case "bleSensor_1":
        return <Bluetooth />;
      case "bleSensor_2":
        return <Wifi />;
      case "s1_favorita_1":
        return <DeviceThermostatIcon />;
      default:
        return <DeviceUnknown />;
    }
  };

  const handlePointMouseLeave = () => {
    setSelectedDevice(null);
  };

  const NextPage = (device) => {
    const partes = device.split("-");
    const antes = partes[0];
    const despues = partes[1];
    let nombreD = partes[2];
    if (nombreD == null || nombreD == undefined || nombreD == "") {
      nombreD = antes;
    }
    let url = `/admin/historico?organizacion=${organizacionn}&localizacion=${localizacionn}&deviceID=${antes}&tipo=${despues}&nombre=${nombreD}`;
    history.push(url);
  };

  const abrirDash = (nombre, id) => {
    let url = `/admin/area?organizacion=${organizacionn}&localizacion=${localizacionn}&area=${nombre}&id=${id}`
    history.push(url);
  }

  const getPointBackgroundColor = (temperature) => {
    const punto = data[0].rango.primerNivel.valor1
    const punto1 = data[0].rango.primerNivel.valor2
    const punto2 = data[0].rango.primerNivel.valor2
    const punto3 = data[0].rango.segundoNivel.valor2
    const punto4 = data[0].rango.segundoNivel.valor2
    const punto5 = data[0].rango.tercerNivel.valor2




    if (temperature != false) {
      if (blink) {
        return ["#FFFFFF", "#FFFFFF"];
      } else {
        if (temperature.temperature >= punto && temperature.temperature < punto1) {
          const percent = (temperature.temperature - punto) / (punto1 - punto);
          const color2 = interpolateColor("#00FFFF", "#0000FF", percent);
          const color1 = interpolateColor("#0000FF", "#00FFFF", percent);
          return [color1, color2];
        } else if (temperature.temperature >= punto2 && temperature.temperature < punto3) {
          const percent = (temperature.temperature - punto2) / (punto3 - punto2);
          const color1 = interpolateColor("#FFFF00", "#00FF00", percent);
          const color2 = interpolateColor("#00FF00", "#FFFF00", percent);
          return [color1, color2];
        } else if (temperature.temperature >= punto4 && temperature.temperature <= punto5) {
          const percent = (temperature.temperature - punto4) / (punto5 - punto4);
          const color1 = interpolateColor("#FFA500", "#FF0000", percent);
          const color2 = interpolateColor("#FF0000", "#FFA500", percent);
          return [color1, color2];
        } else if (temperature.temperature < punto || temperature.temperature > punto5) {
          const percent = 1;
          const color1 = interpolateColor("800080", '#800080', percent);
          const color2 = interpolateColor("800080", '#800080', percent);
          return [color1, color2];
        }
      }


    } else {
      return ["#808080", "#808080"];
    }
  };

  const interpolateColor = (color1, color2, percent) => {
    const hexToRgb = (hex) => {
      const bigint = parseInt(hex.slice(1), 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      return { r, g, b };
    };

    const rgbToHex = (rgb) => {
      return (
        "#" +
        ((1 << 24) | (rgb.r << 16) | (rgb.g << 8) | rgb.b)
          .toString(16)
          .slice(1)
      );
    };

    const color1Rgb = hexToRgb(color1);
    const color2Rgb = hexToRgb(color2);

    const r = Math.round(
      color1Rgb.r + (color2Rgb.r - color1Rgb.r) * percent
    );
    const g = Math.round(
      color1Rgb.g + (color2Rgb.g - color1Rgb.g) * percent
    );
    const b = Math.round(
      color1Rgb.b + (color2Rgb.b - color1Rgb.b) * percent
    );

    return rgbToHex({ r, g, b });
  };

  return (
    <div className="image-container">
      <img ref={imageRef} src={imageUrl} alt="Croquis" />
      {imageWidth > 0 && imageHeight > 0 && (
        <>
          {data.map((item, index) => {
            const { posx, posy } = item.posicionSVG;
            const { x, y } = calculateScaledCoordinates(posx, posy);
            const { deviceID, catalogo, nombre } = item;
            const deviceIcon = getDeviceIcon(catalogo);
            const [color1, color2] = getPointBackgroundColor(item.valores);
            const temperatura = item.valores == false ? "No ha reportado" : item.valores.temperature + "°C";

            return (
              <Tooltip
                key={index}
                title={`${nombre} ${temperatura}`}
                enterDelay={500}
                enterNextDelay={500}
                leaveDelay={200}
                onClose={handlePointMouseLeave}
              >
                <div
                  className="point"
                  style={{
                    left: `${x}%`,
                    top: `${y}%`,
                    background: `linear-gradient(to right, ${color1}, ${color2})`,
                    color: logoColor,
                    zIndex: 2
                  }}
                >
                  <div
                    className="icon-container"
                    onMouseLeave={handlePointMouseLeave}
                    onClick={() =>
                      NextPage(deviceID + "-" + catalogo + "-" + nombre)
                    }
                    style={{
                      zIndex: 2
                    }}
                  >
                    {deviceIcon}
                  </div>
                </div>
              </Tooltip>
            );
          })}
          {dataGateways.map((gateway, index) => {
            const { posicionX, posicionY } = gateway.posiciones;
            const { x, y } = calculateScaledCoordinates(posicionX, posicionY);
            const nombre = gateway.nombre;
            return (
              <div
                key={`gateway-${index}`}
                className="gateway-point"
                style={{
                  position: 'absolute',
                  left: `${x}%`,
                  top: `${y}%`,
                  zIndex: 2
                }}
              >
                {nombre}
              </div>
            );
          })}
          {dataArea.map((item, index) => {
            const { puntoX, puntoY } = item.posiciones
            const { x, y } = calculateScaledCoordinates(puntoX, puntoY);
            const { maxX, maxY } = item.longitudes
            const [color1, color2] = getPointBackgroundColor(item.valores);
            const nombreArea = item.nombreArea;
            const id = item._id
            return (
              <div
                key={`area-${index}`}
                className="gateway-point"
                style={{
                  position: "absolute",
                  left: `${x}%`,
                  top: `${y}%`,
                  height: `${maxY}%`,
                  width: `${maxX}%`,
                  background: `linear-gradient(to right, ${color1}, ${color2})`,
                  zIndex: 1,
                  opacity: 0.4,
                  cursor: 'pointer'
                }}
                // onClick={() => abrirDash(nombreArea, id)}

              >
              </div>
            )
          })}
        </>
      )
      }
    </div >
  );
};

export default ImageWithPoints;
